import React from 'react';
import { useFormikContext } from 'formik';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Error from 'legacy/common/components/wysiwyg-form/Error';
import TextareaAutosize from 'legacy/common/components/wysiwyg-form/TextareaAutoSize';

import { useOrganization } from '../../../../context/EditOrganizationProvider';
import { EditOrganizationFormValues } from '../../../../types/edit-organization';

const Description = () => {
  const { t } = useTranslation(['organizations']);
  const { touched, errors } = useFormikContext<EditOrganizationFormValues>();
  const { data } = useOrganization();

  return (
    <>
      <div
        className={classNames('text-base w-full', {
          'rounded-md px-1': touched.description
        })}
      >
        <TextareaAutosize
          className={classNames(
            'w-full bg-transparent px-1 py-2 placeholder:text-neutral-500',
            {
              '!bg-red-100 rounded-md px-2': errors.description
            }
          )}
          id="description"
          name="description"
          disabled={data.isSubmitting}
          placeholder={t('form.descriptionLabel')}
        />
      </div>
      {errors.description && touched.description && (
        <Error error={errors.description} />
      )}
    </>
  );
};

export default Description;
